import React, { LegacyRef } from 'react'
import { ChevronRight } from '@assets/index'
import './ProfileButton.scss'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import classNames from 'classnames'

export interface ProfileButtonProps {
  buttonType: 'small' | 'medium' | 'large'
  buttonId: string
  buttonText: string
  buttonValue?: string | null | number
  className?: string
  onKeyDownEvent?: (e: React.KeyboardEvent) => void
  onClick?: (e: React.MouseEvent) => void
  onMouseEnter?: (e: React.MouseEvent) => void
  onMouseLeave?: (e: React.MouseEvent) => void
  onFocusEvent?: (e: React.FocusEvent) => void
  buttonRef?: LegacyRef<HTMLDivElement>
  onFocusDown?: string
  disabled?: boolean
}

export const ProfileButton = ({
  buttonType,
  buttonId,
  buttonText,
  onKeyDownEvent,
  onFocusEvent,
  buttonRef,
  buttonValue,
  onClick,
  onMouseLeave,
  onMouseEnter,
  onFocusDown,
  disabled,
}: ProfileButtonProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (disabled) return
    onKeyDownEvent?.(e)
  }

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) return
    onClick?.(e)
  }

  return (
    <div
      id={buttonId}
      className={classNames('profile-button', buttonType, !disabled && 'focusable', disabled && 'disabled')}
      tabIndex={-1}
      onKeyDown={handleKeyDown}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocusEvent}
      ref={buttonRef}
      data-sn-down={onFocusDown}
    >
      <Text tag={TextTag.P} className="innerText">
        <Text tag={TextTag.SPAN}>{buttonText}</Text>
        <Text tag={TextTag.SPAN} className="displayName">
          {buttonValue}
        </Text>
      </Text>
      <ChevronRight />
    </div>
  )
}
